module.exports = __webpack_public_path__ + "img/SEABANK.6ddfc0c0.svg";